import { DatePeriod } from "./datePeriod";
import { DateHelper } from "../../helpers/DateHelper";

export class Week {
    datePeriod: DatePeriod;
    dates: Date[];

    constructor(value: DatePeriod) {
        this.datePeriod = value;
        let from = new Date(value.from);
        let fromString = DateHelper.getDateString(from);
        
        let to = new Date(value.to);
        to.setDate(to.getDate() + 1);
        
        let toString = DateHelper.getDateString(to);

        this.dates = [];
        let i = 0;
        while(fromString != toString){
            this.dates.push(new Date(fromString));
            from.setDate(from.getDate() + 1);
            fromString = DateHelper.getDateString(from);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/models/dates/week.ts